
























































































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";

import RangeSlider from "@/components/VRangeSliderStyling.vue";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue"
import { ColorConstruct } from "@/utilityModels/colorConstruct";

// import CustomInput from '@/commonComponents/customInput/customInput.vue';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import OperateNormalOff from "../resources/operateNormalOff.vue";
import OperateNormalOn from "../resources/operateNormalOn.vue";
import OperateAddOff from "../resources/operateAddOff.vue";
import OperateAddOn from "../resources/operateAddOn.vue";
import OperateRemoveOff from "../resources/operateRemoveOff.vue";
import OperateRemoveOn from "../resources/operateRemoveOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    RangeSlider,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    OperateNormalOff,
    OperateNormalOn,
    OperateAddOff,
    OperateAddOn,
    OperateRemoveOff,
    OperateRemoveOn
  }
})
export default class CurveStyle extends Vue {
    @Prop()
    private layer!: CurveLayer;

    private get mode() { return this.$store.getters.applicationState.curveEditMode; }
    private changeMode(mode: number)
    {
        this.$emit("doCommand", "changeCurveEditMode", { mode : mode });
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    curveStyleContentsOpenAnimate = false;
    curveStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.curveStyleContentsCloseAnimate = true;
        setTimeout(() => {
            this.curveStyleContentsCloseAnimate = false;
            this.curveStyleContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.curveStyleContentsOpenAnimate = true;
        setTimeout(() => {
            this.curveStyleContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    private isColorPickerVisible = false;
    private showColorPicker()
    {
        this.isColorPickerVisible = true;
    }
    private closeColorPicker()
    {
        this.isColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    //↓↓↓↓↓色↓↓↓↓↓

    private get strokeColor(): ColorConstruct
    {
        return this.layer.strokeColor;
    }

    private get strokeColorStyle()
    {
        return {
            background: this.strokeColor.hex
        };
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", false);
    }
    // 色変更完了
    private onChangedColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", true);
    }

    //↑↑↑↑↑色↑↑↑↑↑

    //↓↓↓↓↓透明度↓↓↓↓↓
    private get opacity()
    {
        return this.layer.opacity;
    }
    private get opacitySliderValue()
    {
        return this.opacity;
    }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }
    //↑↑↑↑↑透明度↑↑↑↑↑

    //*** 線幅 ***//
    private get strokeWidth()
    {
        return this.layer.strokeWidth;
    }

    private onChangingValue(value : number, tag : string)
    {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value : number, tag : string)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private changeLayerProperty(
        value: any,
        propertyName: string,
        isFinish: boolean = false,
        isOnce: boolean = false
    )
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish: isFinish,
            isOnce: isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
